export default {
    PORT: process.env.PORT || 8000,
    API_TOKEN: process.env.REACT_APP_API_KEY,
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api"
}
